import { render } from "./editable-grid.vue?vue&type=template&id=31bbd01e&scoped=true&ts=true"
import script from "./editable-grid.vue?vue&type=script&lang=ts"
export * from "./editable-grid.vue?vue&type=script&lang=ts"

import "./editable-grid.vue?vue&type=style&index=0&id=31bbd01e&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bbd01e"]])

export default __exports__